/**
 * Slice orientation defined by `faicore::slicer::PlaneOrientation` enumeration.
 */
export var SliceOrientation;
(function (SliceOrientation) {
    SliceOrientation[SliceOrientation["Axial"] = 0] = "Axial";
    SliceOrientation[SliceOrientation["Frontal"] = 1] = "Frontal";
    SliceOrientation[SliceOrientation["Sagittal"] = 2] = "Sagittal";
    SliceOrientation[SliceOrientation["Oblique"] = 3] = "Oblique";
})(SliceOrientation || (SliceOrientation = {}));
export function getNrrdModule(viewer) {
    return viewer.nrrdModule();
}
